const config = {
    id: 16,
    name: "顶部导航",
    type: 1,
    module_code: "top_nav",
    icon: "icon-tms-top_nav",
    font_icon: "&#xe6d0;",
    style_type: 1,
    link_type: 5,
    link_data: [{
            name: "导航1"
        },
        {
            name: "导航2"
        },
        {
            name: "导航3"
        }
    ],
    property_data: {
        background_color: "#FFFFFF",
        selected_font_color: "#333333",
        unselected_font_color: "#999999"
    }
};

export default config;